module.exports = __webpack_public_path__ + "static/img/4.23f0077.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/4.png
// module id = oiMJ
// module chunks = 1